import React, { useEffect, useState } from "react";
import * as yup from "yup";
import { useDispatch } from "react-redux";
import {
  Box,
  Typography,
  Button,
  FormControl,
  TextField,
  InputAdornment,
  IconButton,
  useTheme,
  Grid,
  useMediaQuery,
  Tabs,
  Tab,
  darken,
  Dialog,
  Select,
  MenuItem,
  InputLabel,
  Tooltip
} from "@mui/material";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import FormTextField from "../form/FormTextField";
import FormDatePicker from "../form/FormDatePicker";
import FormFileInput from "../form/FormFileInput";
import { setAlert } from "../../features/slices/alertSlice";
import Image from "../common/Image";
import { useTranslation } from "react-i18next";
import CopiedTooltip from "../common/CopiedTooltip";
import { useNavigate } from "react-router-dom";
import * as Constant from "../../features/constant";
import CircularProgress from '@material-ui/core/CircularProgress';
import Swal from "sweetalert2";
import Cookies from "js-cookie";
import {
  useSaveTrackingDataMutation,
  useGetBankAccountsQuery
} from "../../features/api/userApiSlice";
import QrCodeIcon from '@mui/icons-material/QrCode';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import {
  useGetDepositCategoryQuery
} from "../../features/api/publicApiSlice"
import TrackFbq from "../common/TrackFbq";
import {
  useLazyGetCryptoAmountQuery
} from "../../features/api/publicApiSlice";
import AddIcon from '@mui/icons-material/Add';

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 1 }}>{children}</Box>}
    </div>
  );
};

const Deposit2 = ({ depositDetails, useDepositMutation }) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const dispatch = useDispatch();
  const mobileView = useMediaQuery(theme.breakpoints.down("sm"));
  const [tabValue, setTabValue] = useState(0);

  const [amount, setAmount] = useState('');
  const [reamount, setReamount] = useState('');
  const [isDisabled, setIsDisabled] = useState(false);
  const [timer, setTimer] = useState(5);
  const [shouldNavigate, setShouldNavigate] = useState(false);
  const [isCooldown, setIsCooldown] = useState(false);
  const [gatewaySubmit, setGatewaySubmit] = useState(false);
  const [eWalletSubmit, setEWalletSubmit] = useState(false);
  const bankDetails = depositDetails?.banks?.filter(
    (detail) => detail?.bankCategory === 'BANK' || !detail?.bankCategory
  ) || [];

  const eWalletDetails = depositDetails?.banks?.filter(
    (detail) => detail?.bankCategory === 'EWALLET'
  ) || [];
  const [selectedBankMethod, setSelectedBankMethod] = useState("bank");
  const [selectedQrCodeMethod, setSelectedQrCodeMethod] = useState("bank");
  const [errorMessage, setErrorMessage] = useState("");
  const [forceUpdate, setForceUpdate] = useState(0);

  const [minDeposit, setMinDeposit] = useState(0);
  const [maxDeposit, setMaxDeposit] = useState(0);

  const [open, setOpen] = useState(false);
  const isKR = process.env.REACT_APP_COUNTRY === "KR";

  const handlePreviewOpen = () => {
    setOpen(true);
  };

  const handlePreviewClose = () => {
    setOpen(false);
  };
  // useEffect(() => {
  //   const savedTimerData = sessionStorage.getItem('timerData');
  //   if (savedTimerData) {
  //     const { endTime } = JSON.parse(savedTimerData);
  //     const now = new Date().getTime();
  //     const timeLeft = Math.round((endTime - now) / 1000);

  //     if (timeLeft > 0) {
  //       setTimer(timeLeft);
  //       setIsDisabled(true);
  //     } else {
  //       sessionStorage.removeItem('timerData');
  //     }
  //   }
  // }, []);

  // useEffect(() => {
  //   if (isDisabled && timer > 0) {
  //     const intervalId = setInterval(() => {
  //       setTimer((prevTimer) => {
  //         if (prevTimer - 1 <= 0) {
  //           sessionStorage.removeItem('timerData');
  //           setIsDisabled(false);
  //         }
  //         return prevTimer - 1;
  //       });
  //     }, 1000);

  //     // Calculate future end time and save in sessionStorage
  //     const endTime = new Date().getTime() + timer * 1000;
  //     sessionStorage.setItem('timerData', JSON.stringify({ endTime }));

  //     return () => clearInterval(intervalId);
  //   }
  // }, [timer, isDisabled]);

  useEffect(() => {
    if (shouldNavigate) {
      navigate(Constant.getPath('/'));
    }
  }, [shouldNavigate, navigate]);

  // const handleClick = () => {
  //   if (!isDisabled) {
  //     setTimer(5);
  //     setIsDisabled(true);
  //   }
  // };

  const [selectedQuickpay, setSelectedQuickpay] = useState(
    depositDetails?.paymentGateways[
      Object?.keys(depositDetails?.paymentGateways)[0]
    ]?.paymentGateway
  );
  const [allQuickpayBank, setAllQuickpayBank] = useState(
    depositDetails?.paymentGateways[
      Object?.keys(depositDetails?.paymentGateways)[0]
    ]?.banks || []
  );
  const [selectedQuickpayBank, setSelectedQuickpayBank] = useState(
    depositDetails?.paymentGateways[
      Object?.keys(depositDetails?.paymentGateways)[0]
    ]?.banks[0]
  );
  const { t } = useTranslation();
  const { data: depositCategory = [] } = useGetDepositCategoryQuery();
  const categorySortOrder = depositCategory?.result || { bank: 1, ewallet: 2, paymentgateway: 3 };

  const depositType = [];
  if (bankDetails && Object.keys(bankDetails).length > 0) {
    depositType.push({ label: t("walletcard.depositpage.title"), category: "bank" });
  }

  if (eWalletDetails && Object.keys(eWalletDetails).length > 0) {
    depositType.push({ label: t("walletcard.depositpage.ewallet"), category: "ewallet" });
  }

  if (depositDetails?.paymentGateways && Object.keys(depositDetails.paymentGateways).length > 0) {
    depositType.push({ label: t("walletcard.depositpage.quickpay.title"), category: "paymentgateway" });
  }

  const depositSchema = yup.object().shape({
    amount: yup
      .number()
      .typeError(t("validation.amountonly"))
      .min(minDeposit, t("validation.minamount"))
      .max(maxDeposit, t("validation.maxamount"))
      .required(t("validation.amountisrequired")),
    receipt: yup.mixed().test("file", t("validation.receipt"), (value) => {
      if (value?.length > 0) {
        return true;
      }
      return false;
    }).test("fileSize", t("validation.filesize"), (value) => {
      // Check if the file size exceeds 1MB
      if (value?.length > 0) {
        const file = value[0];
        return file.size <= 5 * 1024 * 1024;
      }
      return true;
    }),
    // ignore for now
    // promotion: yup.string().required("Please select a promotion."),
  });

  const quickpaySchema = yup.object().shape({
    amount: yup
      .number()
      .typeError(t("validation.amountonly"))
      .min(minDeposit, t("validation.minamount"))
      .max(maxDeposit, t("validation.maxamount"))
      .required(t("validation.amountisrequired")),
  });

  const { control, handleSubmit, setValue, reset } = useForm({
    resolver: yupResolver(depositSchema),
  });

  const {
    control: qpControl,
    handleSubmit: handleQpSubmit,
    setValue: setQpValue,
    reset: resetQp,
  } = useForm({
    resolver: yupResolver(quickpaySchema),
  });

  const sortedDepositType =
    depositCategory?.result && Object.keys(depositCategory.result).length > 0
      ? depositType.slice().sort(
        (a, b) => (categorySortOrder[a.category] ?? 99) - (categorySortOrder[b.category] ?? 99)
      )
      : [];

  const [selectedCategory, setSelectedCategory] = useState(null);

  useEffect(() => {
    if (!selectedCategory && sortedDepositType.length > 0) {
      setSelectedCategory(sortedDepositType[0].category);
    }
  }, [sortedDepositType, selectedCategory]);

  const [selectedBank, setSelectedBank] = useState(bankDetails[0]);
  const [selectedEwalletBank, setSelectedEwalletBank] = useState(eWalletDetails[0]);

  useEffect(() => {
    let selectedMinAmount = selectedCategory === 'bank'
      ? selectedBank?.minAmount
      : selectedCategory === 'paymentgateway'
        ? selectedQuickpayBank?.minAmount
        : selectedCategory === 'ewallet'
          ? selectedEwalletBank?.minAmount
          : undefined;

    let finalMinDeposit;

    const specificMin = selectedMinAmount;
    const globalMin = depositDetails?.minDeposit;

    if (specificMin != null) {
      finalMinDeposit = (globalMin != null) ? Math.max(specificMin, globalMin) : specificMin;
    }
    else {
      finalMinDeposit = globalMin ?? 0;
    }
    setMinDeposit(finalMinDeposit);

    let selectedMaxAmount = selectedCategory === 'bank'
      ? selectedBank?.maxAmount
      : selectedCategory === 'paymentgateway'
        ? selectedQuickpayBank?.maxAmount
        : selectedCategory === 'ewallet'
          ? selectedEwalletBank?.maxAmount
          : undefined;

    let finalMaxDeposit;

    const specificMax = selectedMaxAmount;
    const globalMax = depositDetails?.maxDeposit;

    if (specificMax != null) {
      finalMaxDeposit = (globalMax != null) ? Math.min(specificMax, globalMax) : specificMax;
    }
    else {
      finalMaxDeposit = globalMax ?? 0;
    }

    setMaxDeposit(finalMaxDeposit);

  }, [selectedCategory, selectedBank, selectedQuickpayBank, selectedEwalletBank, depositDetails]);

  const [deposit, { data, isLoading, isError, isSuccess, error }] =
    useDepositMutation();

  const [saveTrackingData] = useSaveTrackingDataMutation();

  const handleTabChange = (event, newValue) => {
    const selectedCategory = sortedDepositType[newValue]?.category;
    setTabValue(newValue);
    setSelectedCategory(selectedCategory);
    setReamount(0);
    setSelectedQrCodeMethod('bank');
  };

  const submitTrackingData = async () => {
    try {
      const fbc = Cookies.get("_fbc");
      const fbp = Cookies.get("_fbp");
      const ttclid = Cookies.get("ttclid");

      const payload = {
        fbc: fbc,
        fbp: fbp,
        ttclId: ttclid
      };
      await saveTrackingData(payload);
    } catch (error) {
      // Handle errors
    }
  }

  const submitDeposit = async (data) => {
    const formData = new FormData();
    //const date = new Date(data.date).toISOString().split("T");
    formData.append("amount", data.amount);
    //formData.append("receiptDateTime", date[0] + ";" + date[1]);
    formData.append("receipt", data.receipt[0]);
    if (selectedCategory === 'bank') {
      formData.append(
        "bankCode",
        selectedBank?.bankCode || bankDetails[0].bankCode
      );
      formData.append("depositMethod", selectedBankMethod);
    }
    else if (selectedCategory === 'ewallet') {
      formData.append(
        "bankCode",
        selectedEwalletBank?.bankCode || selectedEwalletBank[0].bankCode
      );
      formData.append("depositMethod", selectedQrCodeMethod);
    }

    setEWalletSubmit(true);

    if (data.amount > 1000) {
      TrackFbq('trackCustom', 'submitDeposit_' + data.amount);
    }

    await submitTrackingData();
    await deposit({ deposit: formData, paymentGateway: "" }).unwrap().then(() => {
      setEWalletSubmit(false);

      let timerInterval;
      Swal.fire({
        title: t("walletcard.depositpage.deposittitle"),
        html: t("walletcard.depositpage.depositmessage"),
        timer: 3000,
        timerProgressBar: true,
        didOpen: () => {
          Swal.showLoading();
          const timer = Swal.getPopup().querySelector("b");
          timerInterval = setInterval(() => {
            timer.textContent = `${Swal.getTimerLeft()}`;
          }, 100);
        },
        willClose: () => {
          clearInterval(timerInterval);
        }
      }).then((result) => {
        /* Read more about handling dismissals below */
        if (result.dismiss === Swal.DismissReason.timer) {
          setShouldNavigate(true);
          //console.log("I was closed by the timer");
        }

        const cooldownDuration = process.env.REACT_APP_DEPOSIT_TIMER ? Number(process.env.REACT_APP_DEPOSIT_TIMER) : 15;
        const endTime = Date.now() + cooldownDuration * 1000;
    
    
        sessionStorage.setItem(
          "cooldownTimer",
          JSON.stringify({ endTime, isCooldown: true })
        );
    
        setTimer(cooldownDuration);
        setIsCooldown(true);
      });
    }).catch((error) => {
      setEWalletSubmit(false);

      Swal.fire({
        icon: 'error',
        title: error?.data?.message || error?.message || "Something went wrong",
        confirmButtonText: "OK"
      });
    });
    
    // if (!isDisabled) {
    //   setTimer(5);
    //   setIsDisabled(true);
    // }

    // setShowPopup(true);

  };

  const submitQuickpay = async (data) => {
    const formData = new FormData();
    // formData.append("bankCode", selectedQuickpayBank?.bankCode);
    if (isKR && selectedQuickpay === 'SULIFU') {
      if (!selectedUserBank) {
        dispatch(
          setAlert({
            isOpen: true,
            message: t("validation.pleaseselectbank"),
            variant: "error",
          })
        );
        return;
      }
      formData.append("bankCode", selectedUserBank.bankCode);
      formData.append("bankAccountNumber", selectedUserBank.bankAccountNumber);
    } else {
      formData.append("bankCode", selectedQuickpayBank?.bankCode);
    }
    formData.append("amount", data?.amount);

    setGatewaySubmit(true);

    Swal.fire({
      title: t("walletcard.depositpage.gatewaytitle"),
      html: t("walletcard.depositpage.gatewaymessage"),
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    if (data?.amount > 1000) {
      TrackFbq('trackCustom', 'submitDeposit_' + data?.amount);
    }

    await submitTrackingData();
    const res = await deposit({
      deposit: formData,
      paymentGateway: selectedQuickpay,
    })

    if (res) {
      Swal.close();
      setGatewaySubmit(false);

      if (res.data.result.paymentUrl && res.data.result.success === true) {
        navigate(Constant.getPath('/'));
        if (selectedQuickpay === "LNWPAY" || selectedQuickpay === "LNWPAYHK") {
          setTimeout(() => {
            window.location.href = process.env.REACT_APP_GATEWAY_URL_IFRAME + res.data.result.paymentUrl;
          }, 500);
        } else {
          setTimeout(() => {
            window.location.href = res.data.result.paymentUrl
          }, 500);
        }
      } else {
        dispatch(
          setAlert({
            isOpen: true,
            message: t("walletcard.depositpage.paymentgatewayError"),
            variant: "error",
          })
        );
      }
    }
    else {
      Swal.close();
      setGatewaySubmit(false);
    }
    resetQp();
    // if (!isDisabled) {
    //   setTimer(5);
    //   setIsDisabled(true);
    // }
    // navigate(Constant.getPath('/'));
  };

  useEffect(() => {

    if (amount !== "") {
      const processingFee =
        selectedCategory === 'bank'
          ? selectedBank?.processingFee ?? 0
          : selectedCategory === 'paymentgateway'
            ? selectedQuickpayBank?.processingFee ?? 0
            : selectedCategory === 'ewallet'
              ? selectedEwalletBank?.processingFee ?? 0
              : undefined;
      const reamountValue = parseFloat(amount || 0) + parseFloat(processingFee);

      const effectiveMaxDeposit = maxDeposit;

      if (parseFloat(amount) > effectiveMaxDeposit) {
        setErrorMessage(t("validation.maxamount", { max: effectiveMaxDeposit }));
      } else {
        setErrorMessage("");
      }


      setReamount(isNaN(reamountValue) ? "" : reamountValue.toFixed(2));
      setForceUpdate((prev) => prev + 1);
    }
  }, [amount, depositDetails]);


  const handleAmountChange = (event) => {
    setAmount(event.target.value);
  };

  useEffect(() => {
    if (isCooldown && timer > 0) {
      const intervalId = setInterval(() => {
        setTimer((prevTimer) => {
          if (prevTimer - 1 <= 0) {
            clearInterval(intervalId);
            setIsCooldown(false);
            return 0;
          }
          return prevTimer - 1;
        });
      }, 1000);

      return () => clearInterval(intervalId);
    }
  }, [isCooldown, timer]);

  useEffect(() => {
    const savedTimerData = sessionStorage.getItem("cooldownTimer");
    if (savedTimerData) {
      const { endTime, isCooldown } = JSON.parse(savedTimerData);
      const now = Date.now();
      const timeLeft = Math.round((endTime - now) / 1000);

      if (isCooldown && timeLeft > 0) {
        setTimer(timeLeft);
        setIsCooldown(true);
      } else {
        sessionStorage.removeItem("cooldownTimer");
      }
    }
  }, []);

  const handleSubmitClick = () => {
    setTimer(process.env.REACT_APP_DEPOSIT_TIMER ? Number(process.env.REACT_APP_DEPOSIT_TIMER) : 15);
    setIsDisabled(true);
  };

  useEffect(() => {
    if (!isLoading && isSuccess) {
      if (selectedCategory !== "paymentgateway") {
        dispatch(
          setAlert({
            isOpen: true,
            message: t("walletcard.depositpage.successmessage"),
            variant: "success",
          })
        );
      }

      reset();
      TrackFbq('trackCustom', 'CompleteDeposit');
    }
    if (!isLoading && isError) {
      dispatch(
        setAlert({
          isOpen: true,
          message: error?.data?.message,
          variant: "error",
        })
      );
      reset();
    }
  }, [isLoading, isSuccess, isError]);

  const [cryptoAmount, setCryptoAmount] = useState('');
  const [triggerGetCryptoAmount, { cryptoAmountData, cryptoAmountLoading, cryptoAmountError }] = useLazyGetCryptoAmountQuery();

  const getCryptoAmount = async (amount, bankCode, paymentGateway) => {
    const data = await triggerGetCryptoAmount({
      bankCode,
      amount,
      paymentGateway,
    }).unwrap();

    return data.result;
  };

  useEffect(() => {
    const fetchCryptoAmount = async () => {
      if (
        selectedCategory === 'paymentgateway' &&
        selectedQuickpayBank &&
        selectedQuickpay &&
        amount &&
        depositDetails?.paymentGateways[selectedQuickpay]?.isCrypto
      ) {
        const result = await getCryptoAmount(amount, selectedQuickpayBank.bankCode, selectedQuickpay);
        setCryptoAmount(result);
      } else {
        setCryptoAmount('');
      }
    };
    fetchCryptoAmount();
  }, [selectedCategory, selectedQuickpayBank, selectedQuickpay, amount, depositDetails]);

  const {
    data: userBankAccounts,
    isLoading: isUserBankAccountsLoading,
  } = useGetBankAccountsQuery(undefined, {
    skip: !isKR || selectedCategory !== 'paymentgateway', // Only fetch if KR and paymentgateway tab is selected
  });

  const [selectedUserBankId, setSelectedUserBankId] = useState("");

  const selectedUserBank = userBankAccounts?.result?.data?.find(
    (b) => `${b.bankCode}-${b.bankAccountNumber}` === selectedUserBankId
  );
  const bankConfigMap = userBankAccounts?.result?.bankConfigs?.reduce((acc, cfg) => {
    acc[cfg.bankCode] = cfg.bankName;
    return acc;
  }, {});
  useEffect(() => {
    // Pre-select the first bank account for KR users
    if (isKR && userBankAccounts?.result?.data?.length > 0 && !selectedUserBankId) {
      const firstBank = userBankAccounts.result.data[0];
      setSelectedUserBankId(`${firstBank.bankCode}-${firstBank.bankAccountNumber}`);
    }
  }, [isKR, userBankAccounts, selectedUserBankId]);
  return (
    <Box px={1} >
      <Dialog open={open} onClose={handlePreviewClose} maxWidth="sm">
        {selectedBank?.qrCodeUrl && (
          <img
            src={selectedBank?.qrCodeUrl}
            alt="QR Code Full"
            style={{
              width: "100%",
              height: "auto",
            }}
          />
        )}
      </Dialog>

      <Typography fontWeight="bold" color={process.env.REACT_APP_COLOR_TEXT || "white"} sx={{
        marginBottom: "8px"
      }}>
        {t("walletcard.depositpage.paymentMethod")}
      </Typography>

      <Tabs
        onChange={handleTabChange}
      /*        sx={{
                marginLeft: "15px"
              }}*/
      >
        {
          sortedDepositType
            .map((type, index) => (
              <Tab
                icon={
                  <Image
                    width="40px"
                    height="40px"
                    src={process.env.REACT_APP_PROFILE + `/payment_method_` + index + `.png`}
                  />}
                key={index}
                label={type.label}
                sx={{
                  color: theme.palette.primary.main,
                  border:
                    index === tabValue && `2px solid ${theme.palette.primary.main}` ||
                    index !== tabValue && `1px solid ${theme.palette.button.faded.main}`,
                  fontWeight: 600,
                  borderRadius: "5px",
                  padding: "5px 5px",
                  margin: "0  5px",
                  background: "rgba(255,255,255,0.25)",
                  flex: 0,
                  fontSize: "10px",
                }}

              />
            ))
        }
      </Tabs>
      {/* <TabPanel value={tabValue} index={1}> */}
      {selectedCategory === "paymentgateway" && (
        <Box display="flex" flexDirection="column" sx={{
          border: `1px solid ${theme.palette.button.faded.main}`,
          pt: "10px",
          pl: "18px",
          pr: "18px",
          pb: "15px",
          mb: "30px",
          mt: '10px',
          ml: '9px',
          background: "rgba(255,255,255,0.1)"
        }}>
          <Box mb={1}>
            <Typography fontWeight="bold" color={process.env.REACT_APP_COLOR_TEXT || "white"}>
              {t("walletcard.depositpage.quickpay.method")}
            </Typography>
          </Box>
          <Grid container spacing={2}>
            {depositDetails?.paymentGateways && Object.keys(depositDetails?.paymentGateways)?.map((method) => (
              <Grid item xs={6} sm={3}>
                <Box
                  sx={{
                    border: 2.5,
                    borderRadius: 2,
                    borderColor:
                      selectedQuickpay ===
                        depositDetails?.paymentGateways[method]?.paymentGateway
                        ? theme.palette.primary.main
                        : theme.palette.button.faded.main,
                    display: "flex",
                    height: 50,
                    justifyContent: "space-evenly",
                    alignItems: "center",
                    p: 1,
                    backgroundColor: darken(
                      theme.palette.background.paper,
                      0.1
                    ),
                    cursor: "pointer"
                  }}
                  onClick={() => {
                    setSelectedQuickpay(
                      depositDetails?.paymentGateways[method]?.paymentGateway
                    );
                    setAllQuickpayBank(
                      depositDetails?.paymentGateways[method]?.banks
                    );
                    setSelectedQuickpayBank(
                      depositDetails?.paymentGateways[method]?.banks[0]
                    );
                  }}
                >
                  <Image
                    width="40px"
                    height="40px"
                    src={
                      depositDetails?.paymentGateways[method]
                        ?.paymentGatewayIcon
                    }
                  />
                  <Typography ml={mobileView && 1} color="white">
                    {depositDetails?.paymentGateways[method]?.paymentGateway === "LNWPAY" ? "ESEWA" :
                      depositDetails?.paymentGateways[method]?.paymentGateway === "LNWPAYHK" ? "LNWPAY" :
                        depositDetails?.paymentGateways[method]?.paymentGateway
                    }
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
          {isKR && selectedQuickpay === 'SULIFU' ? (
            <Box my={1}>
              <Typography fontWeight="bold" color={process.env.REACT_APP_COLOR_TEXT || "white"} mb={1}>
                {t("walletcard.depositpage.quickpay.bank")}
              </Typography>
              <Box display="flex" alignItems="center" gap={1} mt={1}>
                {isUserBankAccountsLoading ? (
                  <CircularProgress size={24} />
                ) : userBankAccounts?.result?.data?.length > 0 ? (

                  <FormControl fullWidth variant="outlined" size="small">
                    <InputLabel sx={{ color: process.env.REACT_APP_COLOR_TEXT || "white" }}>
                      {t("walletcard.bankaccountpage.bankaccount")}
                    </InputLabel>
                    <Select
                      value={selectedUserBankId || ""}
                      onChange={(e) => {
                        const value = e.target.value;
                        setSelectedUserBankId(value);
                      }}
                      label={t("walletcard.bankaccountpage.bankaccount")}
                      renderValue={(selectedKey) => {
                        const selectedBank = userBankAccounts?.result?.data?.find(
                          (bank) => `${bank.bankCode}-${bank.bankAccountNumber}` === selectedKey
                        );
                        return selectedBank ? (
                          <Box display="flex" flexDirection="column">
                            <Typography variant="body2" fontWeight="bold">
                              {bankConfigMap?.[selectedBank.bankCode] || selectedBank.bankCode}
                            </Typography>
                            <Typography variant="caption" sx={{ opacity: 0.8 }}>
                              {selectedBank.bankAccountNumber}
                            </Typography>
                          </Box>
                        ) : (
                          ""
                        );
                      }}
                      sx={{
                        color: "white",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: theme.palette.button.faded.main,
                        },
                        "& .MuiSvgIcon-root": {
                          color: "white",
                        },
                      }}
                    >
                      {userBankAccounts?.result?.data?.map((bank) => {
                        const key = `${bank.bankCode}-${bank.bankAccountNumber}`;
                        return (
                          <MenuItem key={key} value={key}>
                            <Box display="flex" flexDirection="column">
                              <Typography variant="body2" fontWeight="bold">
                                {bankConfigMap?.[bank.bankCode] || bank.bankCode}
                              </Typography>
                              <Tooltip title={bank.bankAccountNumber}>
                                <Typography variant="caption" noWrap sx={{ opacity: 0.8 }}>
                                  {bank.bankAccountNumber}
                                </Typography>
                              </Tooltip>
                            </Box>
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>

                ) : (
                  <Typography color={process.env.REACT_APP_COLOR_TEXT || "white"} sx={{ flexGrow: 1 }}>
                    {t("walletcard.bankaccountpage.no_bank_account")}
                  </Typography>
                )}
                <Button
                  variant="contained"
                  onClick={() =>
                    navigate(Constant.getPath("/profileWallet"), {
                      state: { screen: "bank account" },
                    })}
                  sx={{ whiteSpace: 'nowrap', height: '56px' }}
                >
                  <AddIcon sx={{ fontSize: 30 }} />
                </Button>
              </Box>
            </Box>
          ) : (
            <>
              <Box my={1}>
                <Typography fontWeight="bold" color={process.env.REACT_APP_COLOR_TEXT || "white"}>
                  {t("walletcard.depositpage.quickpay.bank")}
                </Typography>
              </Box>
              <Grid container spacing={2}>
                {allQuickpayBank?.map((quickpayBank) => (
                  <Grid item xs={6} sm={3}>
                    <Box
                      sx={{
                        border: 2.5,
                        borderRadius: 2,
                        borderColor:
                          selectedQuickpayBank === quickpayBank
                            ? theme.palette.primary.main
                            : darken(theme.palette.background.paper, 0.2),
                        display: "flex",
                        height: 50,
                        justifyContent: "space-evenly",
                        alignItems: "center",
                        p: 1,
                        backgroundColor: darken(
                          theme.palette.background.paper,
                          0.1
                        ),
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        setSelectedQuickpayBank(quickpayBank);
                        setAmount(0);
                        setReamount(0);
                      }}
                    >
                      <Image
                        width="40px"
                        height="40px"
                        src={quickpayBank?.iconUrl}
                      />
                      <Typography ml={mobileView && 1} color="white">
                        {quickpayBank?.bankName}
                      </Typography>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </>
          )}
          <Box mt={1}>
            <Typography fontWeight="bold" color={process.env.REACT_APP_COLOR_TEXT || "white"}>
              {t("walletcard.depositpage.quickpay.depositamount")}
            </Typography>

            <form onSubmit={handleQpSubmit(submitQuickpay)}>
              <Grid item container justifyContent="space-between" spacing={1}>
                <Grid item>
                  <Typography variant="subtitle1" color={process.env.REACT_APP_COLOR_TEXT || "white"} fontSize="14px">{t("Deposit Quota")}</Typography>
                </Grid>
                <Grid item>
                  <Typography variant="subtitle1" color="#FDB813" fontSize="12px">{t(`${process.env.REACT_APP_CURRENCY_CODE} ${minDeposit} - ${process.env.REACT_APP_CURRENCY_CODE} ${maxDeposit}`)}</Typography>
                </Grid>
              </Grid>
              <FormTextField
                label={`${t("walletcard.depositpage.quickpay.amount")} (${process.env.REACT_APP_CURRENCY_CODE
                  })`}
                control={qpControl}
                controllerName="amount"
                defaultValue={""}
                placeholder={`Min ${minDeposit}`}
                size="small"
                onChange={handleAmountChange}

              />
              <Grid container spacing={1} alignItems="center">
                <Grid item>
                  <Typography variant="subtitle1" color={process.env.REACT_APP_COLOR_TEXT || "white"} fontSize="12px">{t("walletcard.depositpage.processingfee")} : </Typography>
                </Grid>
                <Grid item>
                  <Typography fontWeight="bold" color={process.env.REACT_APP_COLOR_TEXT || "white"} align="right" fontSize="12px">
                    {process.env.REACT_APP_CURRENCY_CODE} {selectedQuickpayBank?.processingFee || '0.00'}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container spacing={1} alignItems="center">
                <Grid item>
                  <Typography variant="subtitle1" color={process.env.REACT_APP_COLOR_TEXT || "white"} fontSize="12px">{t("walletcard.depositpage.receivableamount")} : </Typography>
                </Grid>
                <Grid item>
                  {errorMessage ? (
                    // Show error message in place of receivable amount
                    <Typography fontWeight="bold" color="error" align="right" fontSize="12px">
                      {errorMessage}
                    </Typography>
                  ) : (
                    // Show receivable amount if no error
                    <Typography fontWeight="bold" color={process.env.REACT_APP_COLOR_TEXT || "white"} align="right" fontSize="12px">
                      {process.env.REACT_APP_CURRENCY_CODE} {reamount || '0.00'}
                    </Typography>
                  )}
                </Grid>
              </Grid>

              {depositDetails?.paymentGateways[selectedQuickpay]?.isCrypto && (
                <Grid container spacing={1} alignItems="center">
                  <Grid item>
                    <Typography variant="subtitle1" color={process.env.REACT_APP_COLOR_TEXT || "white"} fontSize="12px">
                      {t("walletcard.depositpage.cryptoamount")} :
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography fontWeight="bold" color={process.env.REACT_APP_COLOR_TEXT || "white"} align="right" fontSize="12px">
                      {cryptoAmount}
                    </Typography>
                  </Grid>
                </Grid>
              )}

              <Grid container py={2}>
                {depositDetails?.defaultAmountSelection?.map((item, index) => (
                  <Grid item>
                    <Button
                      key={index}
                      disableRipple
                      sx={{
                        "&.MuiButtonBase-root:hover": {
                          backgroundColor: "transparent",
                        },
                      }}
                      onClick={() => {
                        TrackFbq('trackCustom', 'clickDeposit_' + item.content);

                        setQpValue("amount", item.content, {
                          shouldValidate: true,
                        });
                        setAmount(item.content);
                        // Update reamount when clicking on the button
                        const processingFee = selectedQuickpayBank?.processingFee || 0;
                        const reamountValue = parseFloat(item.content) + parseFloat(processingFee);
                        setReamount(isNaN(reamountValue) ? '' : reamountValue.toFixed(2));
                      }}
                    >
                      <Box
                        display="flex"
                        sx={{
                          border: 1,
                          width: "50px",
                          height: "30px",
                          borderColor: process.env.REACT_APP_COLOR_TEXT || 'white',
                          boxShadow: 3,
                          borderRadius: "5px",
                        }}
                        justifyContent="center"
                        alignItems="center"
                      >
                        <Typography
                          sx={{
                            color: process.env.REACT_APP_COLOR_TEXT || 'white',
                            fontSize: "12px",
                          }}
                        >
                          {item.content}
                        </Typography>
                      </Box>
                    </Button>
                  </Grid>
                ))}
              </Grid>
              <Box display="flex" >
                <Button disabled={gatewaySubmit} color="success" variant="contained" type="submit">
                  {t("walletcard.depositpage.quickpay.deposit")}
                </Button>
                <Box ml={2}>
                  <Button
                    color="error"
                    variant="contained"
                    onClick={() => resetQp()}
                  >
                    {t("walletcard.depositpage.quickpay.clear")}
                  </Button>
                </Box>
              </Box>
            </form>
          </Box>
        </Box>
      )}
      {/* </TabPanel> */}
      {/* <TabPanel value={tabValue} index={0}> */}
      {selectedCategory === "bank" && (
        <Box sx={{
          mt: '10px',
          ml: '9px',
        }}>
          <Box mb={1}>
            <Typography fontWeight="bold" color={process.env.REACT_APP_COLOR_TEXT || "white"}>
              {t("walletcard.depositpage.title")}
            </Typography>
          </Box>
          <Box display="flex" flexDirection="column">
            <Grid container spacing={2}>
              {bankDetails?.map((item, index) => (
                <Grid item key={index} xs={4} sm={2}>
                  <Box
                    sx={{
                      cursor: "pointer",
                      border: selectedBank?.id === item?.id ? 2 : null,
                      borderRadius: 1,
                      borderColor:
                        selectedBank?.id === item?.id
                          ? theme.palette.primary.main
                          : null,
                    }}
                    onClick={() => {
                      TrackFbq('trackCustom', 'affiliate_' + item.bankReference);

                      setSelectedBank(item);
                      setAmount(0);
                      setReamount(0);
                      /*    const processingFee = (selectedBank?.processingFee || bankDetails[0]?.processingFee) || 0;
                          const reamountValue = parseFloat(processingFee);
                          setReamount(isNaN(reamountValue) ? '' : reamountValue.toFixed(2));*/
                    }}
                  >
                    <Image src={item?.thumbnailUrl} />
                  </Box>
                </Grid>
              ))}
            </Grid>

            {selectedBank?.qrCodeUrl && (
              <Box mt={1} >
                <Typography fontWeight="bold" color={process.env.REACT_APP_COLOR_TEXT || "white"} mb={1}>
                  {t("walletcard.depositpage.quickpay.method")}
                </Typography>
                <Grid container spacing={2}>
                  {["bank", "qrCode"].map((method, index) => (
                    <Grid item xs={4} sm={2} key={index}>
                      <Box
                        sx={{
                          border: 2.5,
                          borderRadius: 2,
                          borderColor:
                            selectedBankMethod === method
                              ? theme.palette.primary.main
                              : theme.palette.button.faded.main,
                          display: "flex",
                          height: 50,
                          justifyContent: "center",
                          alignItems: "center",
                          p: 1,
                          backgroundColor: darken(theme.palette.background.paper, 0.1),
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setSelectedBankMethod(method);
                        }}
                      >
                        {method === "bank" ? (
                          <AccountBalanceIcon sx={{ color: "white", mr: 1 }} />
                        ) : (
                          <QrCodeIcon sx={{ color: "white", mr: 1 }} />
                        )}
                        <Typography color="white">
                          {method === "bank"
                            ? t("walletcard.depositpage.bankSubTitle")
                            : t("walletcard.depositpage.qrCode")}
                        </Typography>
                      </Box>
                    </Grid>
                  ))}
                </Grid>
              </Box>
            )}

            <Box display="flex" pl={1} mt={2} flexDirection="column" >
              {selectedBankMethod === "qrCode" && selectedBank?.qrCodeUrl && (
                <Box>
                  <img
                    src={selectedBank.qrCodeUrl}
                    alt="QR Code"
                    style={{ width: "150px", height: "150px", display: "block", margin: "0 auto" }}
                    onClick={handlePreviewOpen}
                  />
                </Box>
              )}
            </Box>

            {selectedBankMethod === "bank" && (
              <Box display="flex" pl={1} mt={1} flexDirection="column">
                <Typography fontWeight="bold" color={theme.palette.primary.main}>
                  {t("walletcard.depositpage.bankingdetails")}
                </Typography>
                <FormControl
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    mt: "5px",
                    "& .MuiTextField-root": {
                      pb: "30px",
                    },
                    border: `1px solid ${theme.palette.button.faded.main}`,
                    pt: "25px",
                    pl: "18px",
                    pr: "18px",
                    mb: "5px",
                    background: "rgba(255,255,255,0.1)"
                  }}
                >
                  <TextField
                    label={t("walletcard.depositpage.bankaccountname")}
                    value={
                      selectedBank?.bankAccountName ||
                      bankDetails[0]?.bankAccountName
                    }
                    InputLabelProps={{ shrink: true }}
                    disabled
                    type="text"
                    size="small"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            disableRipple
                            sx={{
                              "&.MuiButtonBase-root:hover": {
                                backgroundColor: "transparent",
                              },
                            }}
                          >
                            <CopiedTooltip
                              text={
                                selectedBank?.bankAccountName ||
                                bankDetails[0]?.bankAccountName
                              }
                            />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                  <TextField
                    label={t("walletcard.depositpage.bankaccountnumber")}
                    value={
                      selectedBank?.bankAccountNumber ||
                      bankDetails[0]?.bankAccountNumber
                    }
                    InputLabelProps={{ shrink: true }}
                    disabled
                    type="text"
                    size="small"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            disableRipple
                            sx={{
                              "&.MuiButtonBase-root:hover": {
                                backgroundColor: "transparent",
                              },
                            }}
                          >
                            <CopiedTooltip
                              text={
                                selectedBank?.bankAccountNumber ||
                                bankDetails[0]?.bankAccountNumber
                              }
                            />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                  {(selectedBank?.bankBSB || bankDetails[0]?.bankBSB) ? (
                    <TextField
                      label={t("walletcard.depositpage.bankbsb")}
                      value={selectedBank?.bankBSB || bankDetails[0]?.bankBSB}
                      InputLabelProps={{ shrink: true }}
                      disabled
                      type="text"
                      size="small"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              disableRipple
                              sx={{
                                "&.MuiButtonBase-root:hover": {
                                  backgroundColor: "transparent",
                                },
                              }}
                            >
                              <CopiedTooltip
                                text={selectedBank?.bankBSB || bankDetails[0]?.bankBSB}
                              />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  ) : null}

                  <TextField
                    label={t("walletcard.depositpage.bankreference")}
                    value={
                      selectedBank?.bankReference ||
                      bankDetails[0]?.bankReference
                    }
                    InputLabelProps={{ shrink: true }}
                    disabled
                    type="text"
                    size="small"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            disableRipple
                            sx={{
                              "&.MuiButtonBase-root:hover": {
                                backgroundColor: "transparent",
                              },
                            }}
                          >
                            <CopiedTooltip
                              text={
                                selectedBank?.bankReference ||
                                bankDetails[0]?.bankReference
                              }
                            />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </FormControl>
              </Box>
            )}

            <Box display="flex" pl={1} mt={1} flexDirection="column">
              <Typography fontWeight="bold" color={theme.palette.primary.main} mb="5px">
                {t("walletcard.depositpage.depositdetails")}
              </Typography>
              <Box sx={{
                border: `1px solid ${theme.palette.button.faded.main}`,
                pt: "10px",
                pl: "18px",
                pr: "18px",
                mb: "30px",
                background: "rgba(255,255,255,0.1)"
              }}>
                <Grid item container justifyContent="space-between" spacing={1}>
                  <Grid item>
                    <Typography variant="subtitle1" color={process.env.REACT_APP_COLOR_TEXT || "white"} fontSize="14px">{t("Deposit Quota")}</Typography>
                  </Grid>
                  <Grid item>
                    <Typography variant="subtitle1" color="#FDB813" fontSize="12px">{t(`${process.env.REACT_APP_CURRENCY_CODE} ${minDeposit} - ${process.env.REACT_APP_CURRENCY_CODE} ${maxDeposit}`)}</Typography>
                  </Grid>
                </Grid>
                <form onSubmit={handleSubmit(submitDeposit)}>
                  <FormTextField
                    label={`${t("walletcard.depositpage.amount")} (${process.env.REACT_APP_CURRENCY_CODE
                      })`}
                    control={control}
                    controllerName="amount"
                    defaultValue={""}
                    placeholder={t("placeholder.minamount")}
                    size="small"
                    onChange={handleAmountChange}
                  />
                  <Grid container spacing={1} alignItems="center">
                    <Grid item>
                      <Typography variant="subtitle1" color={process.env.REACT_APP_COLOR_TEXT || "white"} fontSize="12px">{t("walletcard.depositpage.processingfee")} : </Typography>
                    </Grid>
                    <Grid item>
                      <Typography fontWeight="bold" color={process.env.REACT_APP_COLOR_TEXT || "white"} align="right" fontSize="12px">
                        {process.env.REACT_APP_CURRENCY_CODE} {selectedBank?.processingFee || bankDetails[0]?.processingFee || '0.00'}

                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid container spacing={1} alignItems="center">
                    <Grid item>
                      <Typography variant="subtitle1" color={process.env.REACT_APP_COLOR_TEXT || "white"} fontSize="12px">{t("walletcard.depositpage.receivableamount")} : </Typography>
                    </Grid>
                    <Grid item>
                      {errorMessage ? (
                        // Show error message in place of receivable amount
                        <Typography fontWeight="bold" color="error" align="right" fontSize="12px">
                          {errorMessage}
                        </Typography>
                      ) : (
                        // Show receivable amount if no error
                        <Typography fontWeight="bold" color={process.env.REACT_APP_COLOR_TEXT || "white"} align="right" fontSize="12px">
                          {process.env.REACT_APP_CURRENCY_CODE} {reamount || '0.00'}
                        </Typography>
                      )}

                    </Grid>
                  </Grid>
                  <Grid container my={3}>
                    {depositDetails?.defaultAmountSelection?.map((item, index) => (
                      <Grid item>
                        <Button
                          key={index}
                          disableRipple
                          sx={{
                            "&.MuiButtonBase-root:hover": {
                              backgroundColor: "transparent",
                            },
                          }}
                          onClick={() => {
                            TrackFbq('trackCustom', 'clickDeposit_' + item.content);

                            setValue("amount", item.content, {
                              shouldValidate: true,
                            });
                            const processingFee = (selectedBank?.processingFee || bankDetails[0]?.processingFee) || 0;
                            const reamountValue = parseFloat(item.content) + parseFloat(processingFee);
                            setReamount(isNaN(reamountValue) ? '' : reamountValue.toFixed(2));
                          }}

                        >
                          <Box
                            display="flex"
                            sx={{
                              border: 1,
                              width: "50px",
                              height: "30px",
                              borderColor: process.env.REACT_APP_COLOR_TEXT || 'white',
                              boxShadow: 3,
                              borderRadius: "5px",
                            }}
                            justifyContent="center"
                            alignItems="center"
                          >
                            <Typography
                              sx={{
                                color: process.env.REACT_APP_COLOR_TEXT || 'white',
                                fontSize: "12px",
                              }}
                            >
                              {item.content}
                            </Typography>
                          </Box>
                        </Button>
                      </Grid>
                    ))}
                  </Grid>
                  {/* <FormDatePicker
                  control={control}
                  label={t("walletcard.depositpage.datetimeonreceipt")}
                  controllerName="receiptDateTime"
                  time={true}
                  size="small"
                /> */}
                  <FormFileInput
                    label={t("walletcard.depositpage.attachment")}
                    control={control}
                    controllerName="receipt"
                    defaultValue={""}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    type="file"
                    margin="dense"
                    size="small"
                  />
                  {/* <FormRadioButton
                title={"Promotion"}
                control={control}
                controllerName="promotion"
                items={radioButton}
              /> */}
                  <Box alignSelf="center" mb={3} mt={2}>
                    {/*                  <Button variant="contained" type="submit">
                    {t("walletcard.submit")}
                  </Button>*/}
                    <Button
                      color="success"
                      variant="contained"
                      type="submit"
                      disabled={isCooldown || eWalletSubmit}
                      onClick={handleSubmitClick}
                      startIcon={isCooldown && <CircularProgress size={20} />}
                      sx={{
                        backgroundColor: isCooldown ? "red" : "success.main",
                        "&:hover": {
                          backgroundColor: isCooldown ? "red" : "success.dark",
                        },
                        "&.Mui-disabled": {
                          backgroundColor: "red",
                          color: "white",
                        },
                      }}
                    >
                      {isCooldown ? `Deposit (${timer}s)` : 'Deposit'}
                    </Button>
                  </Box>
                </form>
              </Box>
              {/*<Typography color={process.env.REACT_APP_COLOR_TEXT || "white"}>*/}
              {/*  {t("walletcard.depositpage.friendlyreminder.title")}*/}
              {/*</Typography>*/}
              {/*<Typography color={process.env.REACT_APP_COLOR_TEXT || "white"} sx={{ textAlign: "justify" }}>*/}
              {/*  <ol>*/}
              {/*    <li style={{ margin: "10px" }}>*/}
              {/*      {t("walletcard.depositpage.friendlyreminder.firstdesc")}*/}
              {/*    </li>*/}
              {/*    <li style={{ margin: "10px" }}>*/}
              {/*      {t("walletcard.depositpage.friendlyreminder.seconddesc")}*/}
              {/*    </li>*/}
              {/*    <li style={{ margin: "10px" }}>*/}
              {/*      {t("walletcard.depositpage.friendlyreminder.thirddesc")}{" "}*/}
              {/*    </li>*/}
              {/*    <li style={{ margin: "10px" }}>*/}
              {/*      {t("walletcard.depositpage.friendlyreminder.fourthdesc")}*/}
              {/*    </li>*/}
              {/*    <li style={{ margin: "10px" }}>*/}
              {/*      {t("walletcard.depositpage.friendlyreminder.fifthdesc")}*/}
              {/*    </li>*/}
              {/*    <li style={{ margin: "10px" }}>*/}
              {/*      {t("walletcard.depositpage.friendlyreminder.sixthdesc")}*/}
              {/*    </li>*/}
              {/*    <li style={{ margin: "10px" }}>*/}
              {/*      {t("walletcard.depositpage.friendlyreminder.seventhdesc")}*/}
              {/*    </li>*/}
              {/*  </ol>*/}
              {/*</Typography>*/}
            </Box>
          </Box>
          {/* </TabPanel> */}
        </Box>
      )}

      {selectedCategory === "ewallet" && (
        <Box sx={{
          mt: '10px',
          ml: '9px',
        }}>
          <Box mb={1} mt={1}>
            <Typography fontWeight="bold" color={process.env.REACT_APP_COLOR_TEXT || "white"}>
              {t("walletcard.depositpage.bankSubTitle")}
            </Typography>
          </Box>
          <Grid container spacing={2} mb={1}>
            {eWalletDetails?.map((item, index) => (
              <Grid item key={index} xs={4} sm={2}>
                <Box
                  sx={{
                    cursor: "pointer",
                    border: selectedEwalletBank?.id === item?.id ? 2 : null,
                    borderRadius: 1,
                    borderColor:
                      selectedEwalletBank?.id === item?.id
                        ? theme.palette.primary.main
                        : null,
                  }}
                  onClick={() => {
                    setSelectedEwalletBank(item);
                    setAmount(0);
                    setReamount(0);
                    setSelectedQrCodeMethod('bank');
                    /*    const processingFee = (selectedBank?.processingFee || bankDetails[0]?.processingFee) || 0;
                        const reamountValue = parseFloat(processingFee);
                        setReamount(isNaN(reamountValue) ? '' : reamountValue.toFixed(2));*/
                  }}
                >
                  <Image src={item?.thumbnailUrl} />
                </Box>
              </Grid>
            ))}
          </Grid>


          {selectedEwalletBank?.qrCodeUrl && (
            <Box>
              <Typography fontWeight="bold" color={process.env.REACT_APP_COLOR_TEXT || "white"} mb={1}>
                {t("walletcard.depositpage.quickpay.method")}
              </Typography>
              <Grid container spacing={2}>
                {["bank", "qrCode"].map((method, index) => (
                  <Grid item xs={4} sm={2} key={index}>
                    <Box
                      sx={{
                        border: 2.5,
                        borderRadius: 2,
                        borderColor:
                          selectedQrCodeMethod === method
                            ? theme.palette.primary.main
                            : theme.palette.button.faded.main,
                        display: "flex",
                        height: 50,
                        justifyContent: "center",
                        alignItems: "center",
                        p: 1,
                        color: "white",
                        backgroundColor: darken(theme.palette.background.paper, 0.1),
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        setSelectedQrCodeMethod(method);
                      }}
                    >
                      {method === "bank" ? (
                        <AccountBalanceIcon sx={{ color: "white", mr: 1 }} />
                      ) : (
                        <QrCodeIcon sx={{ color: "white", mr: 1 }} />
                      )}
                      <Typography color={"white"}>
                        {method === "bank"
                          ? t("walletcard.depositpage.bankSubTitle")
                          : t("walletcard.depositpage.qrCode")}
                      </Typography>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </Box>
          )}



          <Box display="flex" pl={1} mt={2} flexDirection="column" >
            {selectedQrCodeMethod === "qrCode" && selectedEwalletBank?.qrCodeUrl && (
              <Box>
                <img
                  src={selectedEwalletBank.qrCodeUrl}
                  alt="QR Code"
                  style={{ width: "150px", height: "150px", display: "block", margin: "0 auto" }}
                />
              </Box>
            )}
          </Box>

          <Box display="flex" flexDirection="column">
            {selectedQrCodeMethod === "bank" && (
              <Box display="flex" pl={1} mt={1} flexDirection="column">
                <Typography fontWeight="bold" color={theme.palette.primary.main}>
                  {t("walletcard.depositpage.bankingdetails")}
                </Typography>
                <FormControl
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    mt: "5px",
                    "& .MuiTextField-root": {
                      pb: "30px",
                    },
                    border: `1px solid ${theme.palette.button.faded.main}`,
                    pt: "25px",
                    pl: "18px",
                    pr: "18px",
                    mb: "5px",
                    background: "rgba(255,255,255,0.1)"
                  }}
                >
                  <TextField
                    label={t("walletcard.depositpage.bankaccountname")}
                    value={
                      selectedEwalletBank?.bankAccountName ||
                      eWalletDetails[0]?.bankAccountName
                    }
                    InputLabelProps={{ shrink: true }}
                    disabled
                    type="text"
                    size="small"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            disableRipple
                            sx={{
                              "&.MuiButtonBase-root:hover": {
                                backgroundColor: "transparent",
                              },
                            }}
                          >
                            <CopiedTooltip
                              text={
                                selectedEwalletBank?.bankAccountName ||
                                eWalletDetails[0]?.bankAccountName
                              }
                            />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                  <TextField
                    label={t("walletcard.depositpage.bankaccountnumber")}
                    value={
                      selectedEwalletBank?.bankAccountNumber ||
                      eWalletDetails[0]?.bankAccountNumber
                    }
                    InputLabelProps={{ shrink: true }}
                    disabled
                    type="text"
                    size="small"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            disableRipple
                            sx={{
                              "&.MuiButtonBase-root:hover": {
                                backgroundColor: "transparent",
                              },
                            }}
                          >
                            <CopiedTooltip
                              text={
                                selectedEwalletBank?.bankAccountNumber ||
                                eWalletDetails[0]?.bankAccountNumber
                              }
                            />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />

                  {(selectedEwalletBank?.bankBSB || eWalletDetails[0]?.bankBSB) ? (
                    <TextField
                      label={t("walletcard.depositpage.bankbsb")}
                      value={selectedEwalletBank?.bankBSB || eWalletDetails[0]?.bankBSB}
                      InputLabelProps={{ shrink: true }}
                      disabled
                      type="text"
                      size="small"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              disableRipple
                              sx={{
                                "&.MuiButtonBase-root:hover": {
                                  backgroundColor: "transparent",
                                },
                              }}
                            >
                              <CopiedTooltip
                                text={selectedEwalletBank?.bankBSB || eWalletDetails[0]?.bankBSB}
                              />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  ) : null}

                  <TextField
                    label={t("walletcard.depositpage.bankreference")}
                    value={
                      selectedEwalletBank?.bankReference ||
                      eWalletDetails[0]?.bankReference
                    }
                    InputLabelProps={{ shrink: true }}
                    disabled
                    type="text"
                    size="small"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            disableRipple
                            sx={{
                              "&.MuiButtonBase-root:hover": {
                                backgroundColor: "transparent",
                              },
                            }}
                          >
                            <CopiedTooltip
                              text={
                                selectedEwalletBank?.bankReference ||
                                eWalletDetails[0]?.bankReference
                              }
                            />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </FormControl>
              </Box>
            )}

            <Box display="flex" pl={1} mt={1} flexDirection="column">

              <Typography fontWeight="bold" color={theme.palette.primary.main} mb="5px">
                {t("walletcard.depositpage.depositdetails")}
              </Typography>
              <Box sx={{
                border: `1px solid ${theme.palette.button.faded.main}`,
                pt: "10px",
                pl: "18px",
                pr: "18px",
                mb: "30px",
                background: "rgba(255,255,255,0.1)"
              }}>
                <Grid item container justifyContent="space-between" spacing={1}>
                  <Grid item>
                    <Typography variant="subtitle1" color={process.env.REACT_APP_COLOR_TEXT || "white"} fontSize="14px">{t("Deposit Quota")}</Typography>
                  </Grid>
                  <Grid item>
                    <Typography variant="subtitle1" color="#FDB813" fontSize="12px">{t(`${process.env.REACT_APP_CURRENCY_CODE} ${minDeposit} - ${process.env.REACT_APP_CURRENCY_CODE} ${maxDeposit}`)}</Typography>
                  </Grid>
                </Grid>
                <form onSubmit={handleSubmit(submitDeposit)}>
                  <FormTextField
                    label={`${t("walletcard.depositpage.amount")} (${process.env.REACT_APP_CURRENCY_CODE
                      })`}
                    control={control}
                    controllerName="amount"
                    defaultValue={""}
                    placeholder={`Min ${minDeposit}`}
                    size="small"
                    onChange={handleAmountChange}
                  />
                  <Grid container spacing={1} alignItems="center">
                    <Grid item>
                      <Typography variant="subtitle1" color={process.env.REACT_APP_COLOR_TEXT || "white"} fontSize="12px">{t("walletcard.depositpage.processingfee")} : </Typography>
                    </Grid>
                    <Grid item>
                      <Typography fontWeight="bold" color={process.env.REACT_APP_COLOR_TEXT || "white"} align="right" fontSize="12px">
                        {process.env.REACT_APP_CURRENCY_CODE} {selectedEwalletBank?.processingFee || eWalletDetails[0]?.processingFee || '0.00'}

                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid container spacing={1} alignItems="center">
                    <Grid item>
                      <Typography variant="subtitle1" color={process.env.REACT_APP_COLOR_TEXT || "white"} fontSize="12px">{t("walletcard.depositpage.receivableamount")} : </Typography>
                    </Grid>
                    <Grid item>
                      {errorMessage ? (
                        // Show error message in place of receivable amount
                        <Typography fontWeight="bold" color="error" align="right" fontSize="12px">
                          {errorMessage}
                        </Typography>
                      ) : (
                        // Show receivable amount if no error
                        <Typography fontWeight="bold" color={process.env.REACT_APP_COLOR_TEXT || "white"} align="right" fontSize="12px">
                          {process.env.REACT_APP_CURRENCY_CODE} {reamount || '0.00'}
                        </Typography>
                      )}

                    </Grid>
                  </Grid>
                  <Grid container my={3}>
                    {depositDetails?.defaultAmountSelection?.map((item, index) => (
                      <Grid item>
                        <Button
                          key={index}
                          disableRipple
                          sx={{
                            "&.MuiButtonBase-root:hover": {
                              backgroundColor: "transparent",
                            },
                          }}
                          onClick={() => {
                            TrackFbq('trackCustom', 'clickDeposit_' + item.content);

                            setValue("amount", item.content, {
                              shouldValidate: true,
                            });
                            const processingFee = (selectedEwalletBank?.processingFee || eWalletDetails[0]?.processingFee) || 0;
                            const reamountValue = parseFloat(item.content) + parseFloat(processingFee);
                            setReamount(isNaN(reamountValue) ? '' : reamountValue.toFixed(2));
                          }}

                        >
                          <Box
                            display="flex"
                            sx={{
                              border: 1,
                              width: "50px",
                              height: "30px",
                              borderColor: process.env.REACT_APP_COLOR_TEXT || 'white',
                              boxShadow: 3,
                              borderRadius: "5px",
                            }}
                            justifyContent="center"
                            alignItems="center"
                          >
                            <Typography
                              sx={{
                                color: process.env.REACT_APP_COLOR_TEXT || 'white',
                                fontSize: "12px",
                              }}
                            >
                              {item.content}
                            </Typography>
                          </Box>
                        </Button>
                      </Grid>
                    ))}
                  </Grid>
                  {/* <FormDatePicker
                  control={control}
                  label={t("walletcard.depositpage.datetimeonreceipt")}
                  controllerName="receiptDateTime"
                  time={true}
                  size="small"
                /> */}
                  <FormFileInput
                    label={t("walletcard.depositpage.attachment")}
                    control={control}
                    controllerName="receipt"
                    defaultValue={""}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    type="file"
                    margin="dense"
                    size="small"
                  />
                  {/* <FormRadioButton
                title={"Promotion"}
                control={control}
                controllerName="promotion"
                items={radioButton}
              /> */}
                  <Box alignSelf="center" mb={3} mt={2}>
                    {/*                  <Button variant="contained" type="submit">
                    {t("walletcard.submit")}
                  </Button>*/}
                    <Button
                      color="success"
                      variant="contained"
                      type="submit"
                      disabled={isDisabled}
                      //onClick={handleClick}
                      startIcon={isDisabled && <CircularProgress size={20} />}
                    >
                      {isDisabled ? `${timer}s` : 'Deposit'}
                    </Button>
                  </Box>
                </form>
              </Box>
            </Box>
          </Box>
        </Box>
      )}

    </Box>
  );
};

export default Deposit2;
